import { BaseQueryFn } from '@reduxjs/toolkit/dist/query/react';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

export const CSRF_HEADER_KEY = 'anti-csrftoken-a2z';

// ToDo: read from store https://sim.amazon.com/issues/RCMRX-5984
export const getEntityId = () => {
  const entityId = window.AppContext.entityId;
  if (!entityId) {
    throw new Error('entityId is not present');
  }

  return entityId;
};

export const getHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };

  const csrfTokenElements = document.getElementsByName('csrf-token');
  if (csrfTokenElements.length === 0) {
    throw new Error('CSRF security token is not present');
  }

  const csrfToken = (csrfTokenElements[0] as HTMLInputElement).value;
  return { ...headers, [CSRF_HEADER_KEY]: csrfToken };
};

export const axiosBaseQuery =
  ({
    baseUrl = ''
  }): BaseQueryFn<{
    url: string;
    method: AxiosRequestConfig['method'];
    headers: AxiosRequestConfig['headers'];
    data?: AxiosRequestConfig['data'];
    params?: AxiosRequestConfig['params'];
  }> =>
  async ({ url, method, headers, data, params }) => {
    try {
      const response = await axios({ url: baseUrl + url, method, data, params, headers, withCredentials: true });
      return {
        data: response.data
      };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message
        }
      };
    }
  };
